import React from 'react'
import './RefundPolicy.css'
function RefundPolicy() {
  return (
    <div>
  <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Refund & Return Policy</h1>
      <p><strong>Last updated: 22 April 2025</strong></p>

      <h3>1. Eligibility for Refunds or Returns</h3>
      <ul>
        <li>Returns are accepted within 24 hours of delivery.</li>
        <li>Product must be unused, unopened, and in original packaging.</li>
        <li>Proof of damage (photo/video) is required for approval.</li>
      </ul>

      <h3>2. Non-Returnable Items</h3>
      <ul>
        <li>Perishable items like fresh fruits and vegetables are non-returnable unless damaged during shipping.</li>
        <li>Used or opened products are not eligible for return or refund.</li>
      </ul>

      <h3>3. Damaged or Incorrect Items</h3>
      <ul>
        <li>If you receive a damaged or incorrect item, contact us immediately.</li>
        <li>Send photos/videos to our support team.</li>
        <li>We may offer a replacement, partial, or full refund depending on the issue.</li>
      </ul>

      <h3>4. Refund Process</h3>
      <ul>
        <li>Approved refunds will be processed within 5–7 business days.</li>
        <li>Refunds will be issued to your original method of payment.</li>
      </ul>

      <h3>5. Shipping Costs</h3>
      <ul>
        <li>Shipping fees are non-refundable unless the return is due to our mistake.</li>
        <li>Customers are responsible for return shipping costs (if applicable).</li>
      </ul>

      <h3>6. Contact Information</h3>
      <p>For return or refund requests, contact us at:</p>
      <p>📧 Email: support@ahhinternational.com</p>
      <p>📞 Phone: +92 300 1234567</p>
      <p>📍 Address: Head Office, Kamirwala, Pakistan</p>

      <p><strong>Note:</strong> We reserve the right to deny refunds if the conditions above are not met.</p>
    </div>
    </div>
  )
}

export default RefundPolicy
